/* ── Journey state ────────────────────────────────────────
   A tiny mutable store shared between the DOM scroll driver
   (GSAP ScrollTrigger) and the 3D world (R3F useFrame).
   Values mutate every frame WITHOUT touching React state, so
   nothing re-renders while scrolling — the canvas reads them
   inside its render loop, DOM widgets subscribe and only
   setState when a discrete value (active section) changes. */

export const journey = {
  progress: 0, // 0 → 1 across the whole journey
  velocity: 0, // normalized scroll velocity (-1 … 1-ish)
  activeIndex: 0, // discrete section index
  horizontal: true, // desktop horizontal mode vs mobile vertical
  maxScroll: 1, // px the track translates in total (horizontal mode)
  trackX: 0, // current track translateX in px (≤ 0), written per frame
};

const listeners = new Set();

export function subscribeJourney(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function setJourneyProgress(progress, velocity) {
  journey.progress = progress;
  journey.velocity = velocity;
  listeners.forEach((fn) => fn(journey));
}

export function setActiveIndex(i) {
  if (journey.activeIndex === i) return;
  journey.activeIndex = i;
  listeners.forEach((fn) => fn(journey));
}
